import { debounce } from 'lodash';
import { useEffect, useMemo, useState } from 'react';

interface UseDebouncedSearchParamOptions {
  delay?: number;
}

function useDebouncedSearchParam(search: string, options: UseDebouncedSearchParamOptions = {}) {
  const { delay = 300 } = options;
  const [searchParam, setSearchParam] = useState('');

  const debouncedSetSearchParam = useMemo(
    () => debounce((value: string) => setSearchParam(value), delay),
    [delay],
  );

  useEffect(() => {
    if (search) {
      debouncedSetSearchParam(`&search=${encodeURIComponent(search)}`);
    } else {
      debouncedSetSearchParam('');
    }

    return () => {
      debouncedSetSearchParam.cancel();
    };
  }, [debouncedSetSearchParam, search]);

  return { searchParam };
}

export default useDebouncedSearchParam;
